import { StylesConfig } from 'react-select';

const fontStyles = {
  fontWeight: 700,
  fontSize: '1.1rem',
  fontFamily: 'var(--font-inter)',
};

const optionStyles = {
  fontWeight: 400,
  padding: '1rem',
  fontFamily: 'var(--font-inter)',
  color: 'var(--color-black)',
  ':hover': {
    backgroundColor: 'var(--color-pearl)',
  },
  '::active': {
    backgroundColor: 'var(--color-pearl)',
  },
};

const menuStyles = {
  outline: 0,
  border: '1px solid var(--color-pearl)',
  borderRadius: '0.5rem',
  boxShadow: '0px 0.31rem 0.44rem var(--color-black-17-percent)',
};

export const CustomStyles: StylesConfig = {
  control: () => ({}),
  container: (styles) => ({
    ...styles,
    border: 0,
    caretColor: 'var(--color-aqua)',
  }),
  indicatorsContainer: () => ({
    display: 'none',
  }),
  placeholder: (styles) => ({
    ...styles,
    ...fontStyles,
  }),
  singleValue: (styles) => ({
    ...styles,
    ...fontStyles,
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: 0,
  }),
  option: (styles, { isSelected }) => ({
    ...styles,
    background: isSelected ? 'var(--color-pearl)' : 'var(--color-white)',
    ...optionStyles,
  }),
  menu: (styles) => ({
    ...styles,
    ...menuStyles,
  }),
};
